import {chopByPatterns} from './chopByPatterns.js';
import {getTrackJson} from 'engine/json/getTrackJson.js';
import {sleep} from 'utils/sleep.js';
import {
    setLoadingText
} from 'actions/index.js';
import {bouncePadPatterns} from 'engine/BouncingEngine.js';

const getPatternLengths = (sequencerEngine) => {
    let numPatterns = sequencerEngine.tracks[0].patterns.length;
    let patternLengths = [];
    for (let i=0; i < numPatterns; i++) {
        sequencerEngine.switchToPattern(i);
        patternLengths.push(sequencerEngine.length);
    }
    return patternLengths;
};

export const freezePadByPatterns = async (pad) => {
    let {sequencerEngine} = pad;
    sequencerEngine.store.dispatch(setLoadingText("Freezing track\'s patterns"));
    await sleep(100);
    sequencerEngine.stop();

    let tracks = pad.slots.filter(x => x);
    let numPatterns = tracks[0].patterns.length;
    let patternLengths = getPatternLengths(sequencerEngine);
    sequencerEngine.switchToPattern(0);

    let audioBuffer = await bouncePadPatterns(sequencerEngine, pad);
    let bounces = await chopByPatterns(sequencerEngine, audioBuffer, numPatterns, tracks);

    // get preset for group
    let {frozenPad, frozenTracks} = getPadData(pad);
    // delete all the tracks
    for (let track of tracks) {
        sequencerEngine.deleteTrack(track.trackNumber);
    }

    let track = sequencerEngine.addMultiFreezeTrack();
    for (let i=track.patterns.length; i < numPatterns; i++) {
        await track.newPattern(true);
    }
    
    track.freeze(bounces, true);
    track.frozenPad = frozenPad;
    track.frozenTracks = frozenTracks;

    for (let i=0; i < numPatterns; i++) {
        sequencerEngine.switchToPattern(i);
        track.currentPattern = i;
        track.pattern.changeLength(patternLengths[i]);
        track.frozenColumns[0].playing = i;
    }

    sequencerEngine.switchToPattern(0);
    sequencerEngine.switchToPattern(sequencerEngine.currentPattern);

    // update the pattern lengths for this new track to match
    // the max patt. length (of the tracks)
 
    sequencerEngine.store.dispatch(setLoadingText(undefined));
    sequencerEngine.tracks.forEach(
        x => x.trackIsLoading = false);
};

const getPadData = (pad) => {
    let frozenPad = pad.getJsonForPack();
    let frozenTracks = [];
    for (let track of pad.tracks) {
        frozenTracks.push(!track ? false : getTrackJson(track));
    }
    // need to get the steps for each pattern
    return {frozenPad , frozenTracks};
};
